export default __webpack_public_path__ + "static/media/count.cc14719f.svg";